import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-clientes-nuevos',
  templateUrl: './administracion-clientes-nuevos.component.html',
  styleUrls: ['./administracion-clientes-nuevos.component.css']
})
export class AdministracionClientesNuevosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
